import { useSearchParams, useNavigate } from "react-router-dom";
import {
  getReasonPhrase,
  getStatusDescription,
  getStatusEmoji,
} from "../utils/httpStatus";
import "./ErrorPage.css";

export default function ErrorPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get("code") || "500";
  const message = searchParams.get("message");

  // Get title from http-status-codes package
  const title = getReasonPhrase(parseInt(code, 10));

  // Get default description or use provided message
  const description = message || getStatusDescription(code);

  // Get emoji for status code
  const emoji = getStatusEmoji(code);

  return (
    <div className="error-page">
      <div className="error-content">
        <img src="/error_image.jpg" alt="Error" className="error-image" />

        <div className="error-details">
          <h1 className="error-code">
            {emoji} {code}
          </h1>
          <h2 className="error-title">{title}</h2>
          <p className="error-message">{description}</p>

          <div className="error-actions">
            <button onClick={() => navigate("/")} className="btn btn-primary">
              🏠 Go Home
            </button>
            <button onClick={() => navigate(-1)} className="btn btn-secondary">
              ← Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
